export default function ScrollWithOffset(el, smooth) {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = -100;

  if (smooth)
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  else window.scrollTo({ top: yCoordinate + yOffset });
}
